import { OutboundContainerListPage } from "@/features/outbound-container/pages/OutboundContainerListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/outbound-container/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["container.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: OutboundContainerListPage,
});
